import type { ReactElement } from 'react';

import { QUESTION_TYPE_LABELS, type Question } from '@/features/surveys/api';

/**
 * 「どんな設問のアンケートか」を、回答の有無に関わらず確認できるようにする（D-160）。
 *
 * 個別回答・集計結果は回答が無いと何も出ず、事務局・サクセス・理事講師には
 * タイトルしか見えていなかった（実機フィードバック「タイトルあるけど、議題や
 * アンケートの内容がこの画面で知りたい」）。受講生は回答フォーム自体に設問文が
 * 出るため、ここは受講生以外にだけ表示する。
 */
export function SurveyQuestionsPreview({ questions }: { questions: Question[] }): ReactElement {
  if (questions.length === 0) {
    return <p className="text-wptext-muted">設問がありません。</p>;
  }
  return (
    <div className="flex flex-col gap-2">
      {questions.map((q, index) => (
        <div key={q.id} className="rounded-sm border border-wpborder bg-wpcanvas/40 p-2">
          <p className="text-wptext-strong">
            <span className="text-wptext-muted">Q{index + 1}.</span> {q.label}
            <span className="ml-2 text-xs font-normal text-wptext-muted">
              （{QUESTION_TYPE_LABELS[q.type]}
              {q.type === 'description' ? '' : q.required ? '・必須' : '・任意'}）
            </span>
          </p>
          {q.type === 'matrix' ? (
            <p className="mt-1 text-wptext-muted">
              {(q.rows ?? []).map((r) => r.label).join('、')} × {(q.options ?? []).map((o) => o.label).join('、')}
            </p>
          ) : (q.options?.length ?? 0) > 0 ? (
            <p className="mt-1 text-wptext-muted">
              選択肢: {(q.options ?? []).map((o) => o.label).join('、')}
            </p>
          ) : null}
        </div>
      ))}
    </div>
  );
}
